import { React, useEffect, useState } from 'react';
import { NavLink, useNavigate } from "react-router-dom";

import {IconMessage, IconUser, IconSearch, IconHeart, IconCirclePlus } from '@tabler/icons-react';
import Logo from '../../composents/Logo/NavbarLogo/Logo'

import { useDisclosure } from "@mantine/hooks";
import { Modal, TextInput, Button, Stack, Text } from "@mantine/core";

const AppNavbarSyndic = () => {  
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768); 
    const navigate = useNavigate();
    const [openProfileModal, { open: openProfileModalHandler, close: closeProfileModal }] = useDisclosure(false);
    const [, setUser] = useState(null);
    const [hasUnread, setHasUnread] = useState(false);
    const [no, setNo] = useState("");
    const [street, setStreet] = useState("");
    const [postalcode, setPostalcode] = useState("");
    const [city, setCity] = useState("");
    const [country, setCountry] = useState("France");
    const [occupation, setOccupation] = useState("");
    const [errors, setErrors] = useState({});
    const [successModal, setSuccessModal] = useState(false);
    const [needsAddress, setNeedsAddress] = useState(true);
    const [needsOccupation, setNeedsOccupation] = useState(true);


    useEffect(() => {
        getUser().then((data) => {
            if (data?._id) checkUnread(data._id);
        });
        const handleResize = () => {
          setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

    const checkUnread = async (userId) => {
        try {
            const token = localStorage.getItem("token");
            if (!token) return;

            const res = await fetch("https://boldee-97d8d36af3bd.herokuapp.com/app/msg/conversations", {
                headers: { Authorization: `Bearer ${token}` }
            });
            const conversations = await res.json();
            const unread = conversations.some(conv => (conv.unreadCount?.[userId] || 0) > 0);
            setHasUnread(unread);
        } catch {
            // silencieux
        }
    };

    const getUser = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) return null;
            const response = await fetch('https://boldee-97d8d36af3bd.herokuapp.com/app/getUser', {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
                // On ne déconnecte que si le token envoyé avec CETTE requête est toujours celui
                // en place (évite qu'une requête en vol, répondant après un logout/login
                // entre-temps, redéclenche une déconnexion sur un token qui n'est plus le bon).
                if (response.status === 401) {
                    if (localStorage.getItem("token") === token) {
                        localStorage.removeItem("token");
                        sessionStorage.removeItem("user");
                        sessionStorage.removeItem("userType");
                        navigate("/app/login");
                    }
                    return null;
                }
                const data = await response.json();
                setUser(data);
                return data;
            }   catch (error) {
                return null;
            }
    };

    const validateFields = () => {
        const newErrors = {};

        if (needsAddress) {
            if (!street) newErrors.street = "Adresse requise";
            if (!postalcode) newErrors.postalcode = "Code postal requis";
            if (!city) newErrors.city = "Ville requise";
            if (!country || country.trim().length === 0) {
                newErrors.country = "Pays requis";
            }
        }

        if (needsOccupation && (!occupation || occupation.trim().length < 2)) {
            newErrors.occupation = "Fonction requise";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
        };

    const isAddressComplete = (address) => {
        if (!address) return false;

        const { street, postalcode, city, country } = address;

        return [street, postalcode, city, country].every(
            (field) => field && field.trim() !== ""
        );
    };

    const handlePublishClick = async (e) => {
        e.preventDefault();
        const freshUser = await getUser();
        // getUser() peut renvoyer null sur un échec réseau/serveur transitoire (pas seulement
        // si le profil est vraiment incomplet) : dans ce cas on ne doit pas rouvrir à tort le
        // modal "Complétez votre profil" alors qu'il l'est déjà, juste réessayer.
        if (!freshUser) {
            navigate('/app/offers/add');
            return;
        }
        const addressComplete = isAddressComplete(freshUser?.company?.address);
        const occupationComplete = !!freshUser?.occupation;
        if (!(addressComplete && occupationComplete)) {
            setNeedsAddress(!addressComplete);
            setNeedsOccupation(!occupationComplete);
            openProfileModalHandler();
        } else {
            navigate('/app/offers/add');
        }
    };

    const formatText = (value) => {
        if (!value) return "";
        const trimmed = value.trim().toLowerCase();
        return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
    };

    const handleAddressSubmit = async () => {
        try {
            const token = localStorage.getItem("token");

            if (needsAddress) {
                const formattedStreet = formatText(street);
                const formattedCity = formatText(city);
                const formattedCountry = formatText(country);

                const response = await fetch(
                "https://boldee-97d8d36af3bd.herokuapp.com/app/profile/addAddress",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        no : no || "",
                        street: formattedStreet,
                        postalcode,
                        city: formattedCity,
                        country: formattedCountry,
                    }),
                }
                );

                const data = await response.json();

                if (!response.ok) {
                    throw new Error(data.message);
                }
            }

            if (needsOccupation) {
                const roleResponse = await fetch(
                "https://boldee-97d8d36af3bd.herokuapp.com/app/profile/addRole",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                    body: JSON.stringify({ role: occupation }),
                }
                );

                const roleData = await roleResponse.json();

                if (!roleResponse.ok) {
                    throw new Error(roleData.message);
                }
            }

            setNo("");
            setStreet("");
            setPostalcode("");
            setCity("");
            setCountry("France");
            setOccupation("");
            closeProfileModal();
            await getUser();
            setSuccessModal(true);

        } catch (error) {
            console.error(error.message);
        }
    };
          
    return(
        <div className="app-navbar">
            {isMobile ? (
                <>
                    <ul id="app-navbar-container">
                        <NavLink to = "/app/research/list" activeClassName="active">
                            <IconSearch />
                            <p id="navFavorisSyndicga4">Rechercher</p>
                        </NavLink>
                        <NavLink to = "/app/fav/list" activeClassName="active">
                            <IconHeart />
                            <p id="navFavorisSyndicga4">Favoris</p>
                        </NavLink>
                        <NavLink
                            to="/app/offers/add"
                            onClick={handlePublishClick}  
                            activeClassName="active">
                            <IconCirclePlus />
                            <p id="navProfilSyndic">Publier</p>
                        </NavLink>

                        <Modal
                            opened={openProfileModal}
                            onClose={closeProfileModal}
                            title="Complétez votre profil"
                            fullScreen={isMobile}
                            centered
                            zIndex={1000}
                            >
                                <Text size="sm" c="dimmed" mb="md" className='noMrgT mrgB5'>
                                    {needsAddress && needsOccupation
                                        ? "Adresse et fonction requises pour publier une offre."
                                        : needsAddress
                                        ? "Adresse requise pour publier une offre."
                                        : "Fonction requise pour publier une offre."}
                                </Text>
                            <Stack>

                                {needsOccupation && (
                                    <TextInput
                                        label="Fonction"
                                        placeholder="Ex : Responsable des achats"
                                        value={occupation}
                                        error={errors.occupation}
                                        onChange={(e) => setOccupation(e.currentTarget.value)}
                                        required
                                        className='noMrgTB'
                                    />
                                )}

                                {needsAddress && (
                                    <>
                                        <TextInput
                                            label="N°"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            value={no}
                                            onChange={(e) =>
                                                setNo(e.currentTarget.value.replace(/[^0-9]/g, ""))
                                            }
                                        />

                                        <TextInput
                                            mt="xs"
                                            label="Adresse"
                                            placeholder="Ex : rue de Paris"
                                            value={street}
                                            error={errors.street}
                                            onChange={(e) => setStreet(e.currentTarget.value)}
                                            required
                                            className='noMrgTB'
                                        />

                                        <TextInput
                                            mt="xs"
                                            label="Code postal"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            maxLength={5}
                                            value={postalcode}
                                            error={errors.postalcode}
                                            onChange={(e) =>
                                                setPostalcode(
                                                e.currentTarget.value
                                                    .replace(/[^0-9]/g, "")
                                                    .slice(0, 5)
                                                )
                                            }
                                            required
                                            className='noMrgTB'
                                        />

                                        <TextInput
                                            mt="xs"
                                            label="Ville"
                                            value={city}
                                            error={errors.city}
                                            onChange={(e) => setCity(e.currentTarget.value)}
                                            required
                                            className='noMrgTB'
                                        />

                                        <TextInput
                                            mt="xs"
                                            label="Pays"
                                            value={country}
                                            error={errors.country}
                                            onChange={(e) => setCountry(e.currentTarget.value)}
                                            required
                                            className='noMrgTB'
                                        />
                                    </>
                                )}

                                <Button
                                    fullWidth
                                    mt="md"
                                    color="dark"
                                    onClick={async () => {

                                        const isValid = validateFields();
                                        if (!isValid) return;
                                        await handleAddressSubmit();
                                    }}
                                    >
                                    Enregistrer
                                </Button>

                                <div className='mrgB100'></div>



                            </Stack>
                            </Modal>

                            <Modal
                                opened={successModal}
                                onClose={() => {
                                    setSuccessModal(false);
                                    navigate("/app/research/list");
                                }}
                                title="Adresse enregistrée"
                                centered
                                >
                                <Button
                                    fullWidth
                                    mt="md"
                                    onClick={() => navigate("/app/offers/add")}
                                    color="dark"
                                >
                                    Publier une offre
                                </Button>
                            </Modal>


                        <NavLink to = "/app/msg/list" activeClassName="active">
                            <div style={{ position: "relative", display: "inline-flex" }}>
                                <IconMessage />
                                {hasUnread && (
                                    <span style={{
                                        position: "absolute",
                                        top: 0,
                                        right: 0,
                                        width: 8,
                                        height: 8,
                                        borderRadius: "50%",
                                        backgroundColor: "red"
                                    }} />
                                )}
                            </div>
                            <p id="navOffresSyndic" className='w10-offerMenu'>Messages</p>
                        </NavLink>
                        
                        <NavLink to = "/app/profile/menu" activeClassName="active">
                            <IconUser/>
                            <p id="navProfilSyndic">Profil</p>
                        </NavLink>
                    </ul>
                </>
            ) : (
                <>
                    <div className='horizontal iCenter w100 appMenuBorder'>
                        <Logo/>
                        <div className='wMenu txt18'>
                            <NavLink to="/app/research/list" className="aReset" activeClassName="active">
                                <p id="navFavorisSyndicga4" className='bT bold'>Rechercher</p>
                            </NavLink>
                            <NavLink to="/app/fav/list" className="aReset" activeClassName="active">
                                <p id="navFavorisSyndicga4" className='bT bold'>Favoris</p>
                            </NavLink>
                            <NavLink
                                to="/app/offers/add"
                                className="aReset"
                                onClick={handlePublishClick}
                                activeClassName="active">
                                <p id="navProfilSyndic" className='bT bold'>Publier</p>
                            </NavLink>

                        <NavLink to="/app/msg/list" className="aReset" activeClassName="active">
                            <p id="navOffresSyndic" className='w10-offerMenu bT bold' style={{ position: "relative" }}>
                                Messages
                                {hasUnread && (
                                    <span style={{
                                        position: "absolute",
                                        top: 0,
                                        right: -10,
                                        width: 8,
                                        height: 8,
                                        borderRadius: "50%",
                                        backgroundColor: "red"
                                    }} />
                                )}
                            </p>
                        </NavLink>

                        <NavLink to="/app/profile/menu" className="aReset" activeClassName="active">
                            <p id="navProfilSyndic" className='bT bold'>Profil</p>
                        </NavLink>
                        </div>
                    </div>

                        <Modal
                            opened={openProfileModal}
                            onClose={closeProfileModal}
                            title="Complétez votre profil"
                            fullScreen={isMobile}
                            centered
                            zIndex={1000}
                            >
                                <Text size="sm" c="dimmed" mb="md" className='noMrgT mrgB5'>
                                    {needsAddress && needsOccupation
                                        ? "Adresse et fonction requises pour publier une offre."
                                        : needsAddress
                                        ? "Adresse requise pour publier une offre."
                                        : "Fonction requise pour publier une offre."}
                                </Text>
                            <Stack>

                                {needsOccupation && (
                                    <TextInput
                                        label="Fonction"
                                        placeholder="Ex : Responsable des achats"
                                        value={occupation}
                                        error={errors.occupation}
                                        onChange={(e) => setOccupation(e.currentTarget.value)}
                                        required
                                        className='noMrgTB'
                                    />
                                )}

                                {needsAddress && (
                                    <>
                                        <TextInput
                                            label="N°"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            value={no}
                                            onChange={(e) =>
                                                setNo(e.currentTarget.value.replace(/[^0-9]/g, ""))
                                            }
                                        />

                                        <TextInput
                                            mt="xs"
                                            label="Adresse"
                                            placeholder="Ex : rue de Paris"
                                            value={street}
                                            error={errors.street}
                                            onChange={(e) => setStreet(e.currentTarget.value)}
                                            required
                                            className='noMrgTB'
                                        />

                                        <TextInput
                                            mt="xs"
                                            label="Code postal"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            maxLength={5}
                                            value={postalcode}
                                            error={errors.postalcode}
                                            onChange={(e) =>
                                                setPostalcode(
                                                e.currentTarget.value
                                                    .replace(/[^0-9]/g, "")
                                                    .slice(0, 5)
                                                )
                                            }
                                            required
                                            className='noMrgTB'
                                        />

                                        <TextInput
                                            mt="xs"
                                            label="Ville"
                                            value={city}
                                            error={errors.city}
                                            onChange={(e) => setCity(e.currentTarget.value)}
                                            required
                                            className='noMrgTB'
                                        />

                                        <TextInput
                                            mt="xs"
                                            label="Pays"
                                            value={country}
                                            error={errors.country}
                                            onChange={(e) => setCountry(e.currentTarget.value)}
                                            required
                                            className='noMrgTB'
                                        />
                                    </>
                                )}

                                <Button
                                    fullWidth
                                    mt="md"
                                    color="dark"
                                    onClick={async () => {

                                        const isValid = validateFields();
                                        if (!isValid) return;
                                        await handleAddressSubmit();
                                    }}
                                    >
                                    Enregistrer
                                </Button>

                                <div className='mrgB75'></div>

                            </Stack>
                            </Modal>

                            <Modal
                                opened={successModal}
                                onClose={() => {
                                    setSuccessModal(false);
                                    navigate("/app/research/list");
                                }}
                                title="Adresse enregistrée"
                                centered
                                >
                                <Button
                                    fullWidth
                                    mt="md"
                                    onClick={() => navigate("/app/offers/add")}
                                    color="dark"
                                >
                                    Publier une offre
                                </Button>
                            </Modal>
                </>
            )}
        </div>
    )
    
}

export default AppNavbarSyndic;